module.exports = __webpack_public_path__ + "img/SeebrückeSeelin.af21950d.jpg";